import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Recorder } from "./recorder";
import { uploadVideo } from "./helper";

export const AdditionalInfo = () => {
  const [video, setVideo] = useState(null);
  const navigate = useNavigate();

  const onSubmit = async () => {
    const shouldNavigate = await uploadVideo(video, "video2");
    if (shouldNavigate) navigate("/settings/intro-videos");
  };

  const props = {
    allowManualSubmission: true,
    setVideo,
    onSubmit: video ? onSubmit : null,
  };
  return (
    <Recorder
      {...props}
      heading="Additional Info"
      body="Present any notable industry achievements, accolades or certifications you have. Mention any celebrities, notable brands or companies you've worked with."
    />
  );
};
